// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_rEt","cls2":"CreateSocialItemModal-cls2_NGn CreateSocialItemModal-cls1_rEt"};